import React from "react";
import { Box, Card, CardHeader, CardMedia, Typography } from "@mui/material";
import { Slide } from "../designs_slideshow";
import styles from "./styles.module.scss";
import Link from "next/link";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CommonCarouselComponent from "../carousal/common_carousel";
import Image from "next/image";

export interface CardsCarouselData {
    name?: string,
    cards: Slide[],
    dispatcher?: any,
    action?: any,
    imageFill?: string,
    showLabel?: boolean;
    minWidth?: string;
    maxWidth?: string;
    catPage?: boolean;
    fullWidth?: boolean;
}

const CardsCarouselComponent: React.FC<CardsCarouselData> = (cardsCarouselData) => {

    const { cards, dispatcher, showLabel = true, minWidth = '200px', maxWidth = '200px', catPage = false, fullWidth=false } = cardsCarouselData;
    const imageFill = cardsCarouselData.imageFill ?? "cover";

    const generateStyleCards = () => {
        const cardsDom: any[] = [];

        cards?.forEach((card: Slide, index: number) => {
            cardsDom.push(
                <Card key={'styleType' + (card.name ? card.name : "") + index} className={styles["style-class-cards"]} sx={{
                    m: 1, minWidth: minWidth, maxWidth: maxWidth,
                    borderColor: card.selected ? "#FE6526 !important" : 'transparent'
                }}>
                    <Box className={styles[card.selected ? "selected-card" : ""]} id={'roomStyle_' + (card.name ? card.name : index)} onClick={() => dispatcher && dispatcher(card, index)} component={card.link ? Link : "div"} href={card.link ? card.link : "#"}>
                        <Box component="span"
                            className={`${styles.image_wrapper} ${styles[imageFill]}`}
                            sx={{
                                borderWidth: '2px',
                                borderStyle: 'solid',
                                borderRadius: '8px',
                                borderColor: card.selected ? (theme) => theme.palette.primary.main : 'lightgray'
                            }}><Image
                                src={card.image || "/images/broken_image.png"}
                                width={200}
                                height={140}
                                className={styles[card.selected ? "slide-image-selected" : "slide-image"]}
                                alt={card.displayName || card.name || card.image}  
                            />
                        </Box>
                        <Typography className={styles["style-cards-title"]} variant="body2" sx={{ color: 'primary', paddingTop: '5px' }}>{card.displayName || card.name}</Typography>
                    </Box>
                </Card>
            );
        })
        return cardsDom
    }

    return (
        <>
            {showLabel && <div className={styles["select-style"]}>
                Select a style <ArrowForwardIosIcon fontSize="large" />
            </div>}
            <div className={styles["styles-panel"]}>
                {(!cards) ?
                    <span>loading ...</span>
                    :
                    (
                        <CommonCarouselComponent fullWidth={fullWidth} cards={generateStyleCards()} />
                    )
                }
            </div>
        </>
    );
}
export default CardsCarouselComponent;